import {useLayoutEffect, useState} from 'react';

/** @module hooks/use-window-size */

interface WindowSize {
    width: number | undefined;
    height: number | undefined;
}

/**
 * Custom hook to get the current window dimensions (width and height)
 * @returns The current window dimensions
 *
 * @memberof module:hooks/use-window-size
 */
const useWindowSize = (): WindowSize => {
    /*
     * Initialize state with undefined width/height so server and client renders match
     * More here: https://joshwcomeau.com/react/the-perils-of-rehydration/
     */
    /* eslint-disable no-undefined */
    const [size, setSize] = useState<WindowSize>({
        width: undefined,
        height: undefined,
    });
    /* eslint-enable no-undefined */

    useLayoutEffect(() => {
        const handleResize = () => {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return size;
};

export default useWindowSize;
